<template>
    <div>
        <div class="user-box">
          <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
            <van-list
              v-model="loading"
              :finished="finished"
              finished-text="没有更多了"
              @load="onLoad"
            >
            <div class="cell" v-for="(item, index) in list" @click="selectBusiness(item.user_id, index)">
                <van-cell is-link>
                    <template slot="title">
                        <img :src="item.face"
                             alt="" class="cell-img">
                        <div class="custom-title">{{item.name}}</div>
                        <div class="van-cell__label">{{item.role_type}}</div>
                    </template>
                </van-cell>
            </div>
            </van-list>
          </van-pull-refresh>

            <div class="createbtn">
                <van-button type="danger" size="large" @click="toUserCreate">新增</van-button>
            </div>
        </div>
    </div>
</template>
<style scoped>
    .user-box {
        margin-bottom: 50px;
    }

    .createbtn {
        position: fixed;
        bottom: 0;
        width: 100%;
    }

    .cell-img {
        width: 48px;
        height: 48px;
        float: left;
        border-radius: 50%;
        margin-right: 15px;
    }

    .van-cell__right-icon {
        line-height: 48px;
    }

</style>

<script>
    import Vue from 'vue';
    import {Dialog, Toast} from 'vant';

    Vue.use(Dialog).use(Toast);

    export default {
        name: 'SiteSettingUser',
        components: {},
        data: function () {
            return {
                isLoading: false,
                loading: false,
                finished: false,
                params: {
                    page: 1,
                    pageSize: 10,
                },
                list: []
            }
        },
        filter: {},
        mounted() {
            document.title = "人员管理"
            this.getBusinessUserList();
        },
        destroyed() {
        },
        methods: {
            getBusinessUserList(ref) {
                let that = this;
                that.$api.get('/wyhadminapi/weiyuanhui/getWyhUserList', that.params, (res) => {

                    that.loading = false;
                    that.params.page += 1;

                    if (res.data.currentpage == 1) {
                        if (ref) {
                            that.$toast('刷新成功');
                        }
                        that.isLoading = false;
                        that.list = res.data.list;
                    } else {
                        let list = that.list.concat(res.data.list);
                        that.list = list;
                    }
                    if (res.data.list.length == 0) {
                        that.finished = true;
                    }
                })
            },

            selectBusiness(user_id, index) {
                let that = this;
                Dialog.confirm({
                    title: '删除用户',
                    message: '确定删除该用户吗?'
                }).then(() => {
                    // on confirm
                    that.$api.get('/badminapi/business/deleteBusinessUser', {'user_id': user_id}, (res) => {
                        Toast.success('删除成功')
                        that.list.splice(index, 1);
                    })
                }).catch(() => {
                    // on cancel
                });
            },

            toUserCreate() {
                rbLink({name: 'SiteSettingUserCreate'})
                // this.$router.push({name: 'SiteSettingUserCreate'})
            },

            // 上拉加载
            onLoad() {
                // 异步更新数据
                if(this.params.page > 1) {
                    setTimeout(() => {
                        this.getBusinessUserList()
                    }, 500);
                }
            },

            onRefresh() {
                let that = this;
                that.params.page = 1;
                this.getBusinessUserList(1)
            },
        }
    }
</script>



// WEBPACK FOOTER //
// SiteSettingUser.vue?e5cfcd5a